export default {"src":"/_next/static/image/public/images/icons1/5.a1b7ee02d30b837dc07ea3e061b588d5.svg","height":25,"width":22};